import { shallowEqual, useSelector } from 'react-redux'

import { ActionBarLeft, ActionBarRight, ActionBarWrapper } from '@components/UI/Card/Card.styled'
import { useInboxFilter } from '@hooks/useInboxFilter'
import { IApplicationState } from '@store/index'
import { ISubmission, selectComparisonLink } from '@store/submissions'
import ActionBarIconApprove from '../Icon/Approve/Approve'
import ActionBarIconChat from '../Icon/Chat'
import ActionBarIconCompareSubmission from '../Icon/CompareSubmission/CompareSubmission'
import ActionBarIconDecline from '../Icon/Decline/Decline'

interface IProps {
  campaignId: number
  submission: ISubmission
  hasDeclineLink: boolean
  hasFeedbackLink: boolean
  hasApproveLink: boolean
}

const SubmissionCardActionBarSocialPreApproved: React.FC<IProps> = ({
  hasDeclineLink,
  hasApproveLink,
  hasFeedbackLink,
  submission,
  campaignId,
}) => {
  const { currentFilter } = useInboxFilter()
  const { hasComparisonLink } = useSelector((state: IApplicationState) => ({
    hasComparisonLink: Boolean(selectComparisonLink(state, submission.id)),
  }), shallowEqual)

  const modalProps = {
    currFilter: currentFilter,
    submission,
    campaignId,
  }

  return (
    <ActionBarWrapper justifyBetween>
      <ActionBarLeft>
        {hasFeedbackLink && <ActionBarIconChat submission={submission} campaignId={campaignId} />}
        {hasComparisonLink && (
          <ActionBarIconCompareSubmission submissionId={submission.id} campaignId={campaignId} />
        )}
      </ActionBarLeft>
      <ActionBarRight>
        {hasDeclineLink && <ActionBarIconDecline modalProps={modalProps} />}
        {hasApproveLink && <ActionBarIconApprove modalProps={modalProps} highlighted />}
      </ActionBarRight>
    </ActionBarWrapper>
  )
}

export default SubmissionCardActionBarSocialPreApproved
